(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initElementAnimations = function () {
        var elements = document.querySelectorAll('[data-anim="element"]');

        if (!elements.length) {
            return;
        }

        function getDelay(element) {
            var delay = element.getAttribute('data-anim-delay');

            if (!delay) {
                return '';
            }

            if (/ms$|s$/i.test(delay)) {
                return delay;
            }

            return delay + 's';
        }

        elements.forEach(function (element) {
            var delay = getDelay(element);

            if (delay) {
                element.style.setProperty('--anim-delay', delay);
            }
        });

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            elements.forEach(function (element) {
                element.classList.add('is-inview');
            });
            return;
        }

        if (!('IntersectionObserver' in window)) {
            elements.forEach(function (element) {
                element.classList.add('is-inview');
            });
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                entry.target.classList.add('is-inview');
                observer.unobserve(entry.target);
            });
        }, {
            rootMargin: '0px 0px -50px 0px',
            threshold: 0,
        });

        elements.forEach(function (element) {
            observer.observe(element);
        });
    };
})();
